<template>
  <form @submit.prevent="resetPassword()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          Reset Password (user will be prompted to change it next time they log in)
        </p>
      </header>
      <section class="modal-card-body">
        <d-field label="New Password*">
          <d-input v-model="form.newPassword " type="password" required />
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Close
        </d-btn>
        <d-btn :loading="saving" type="submit">
          Reset
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
  import axios from 'axios';

  export default {
    parent: true,

    props: {
      userId: {
        type: String,
        default: '',
      },
    },
    data: () => ({
      saving: false,
      form: {
        newPassword: '',
      },
    }),

    methods: {
      async resetPassword() {
        this.saving = true;
        try {
          await axios.post(`/api/qcp-users/${this.userId}/reset-password?password=${this.form.newPassword}`);
          this.$toast.open({ message: 'Password reset', color: 'success', duration: 4000 });
          this.$parent.close();
        } catch (error) {
          this.$toast.open({ message: error.response.data[0], color: 'error', duration: 4000 });
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>